"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { useLocale, useTranslations } from "next-intl";
import InfoIcon from "@/assets/icons/ontario-icon-alert-information.svg";
import { Container, InnerContainer, StyledCreateAccount, StyledCloseIcon } from "./styles";
const CreateAccountBanner: React.FC = () => {
  const $ = _c(10);
  const t = useTranslations("Common.components.createAccountBanner");
  const locale = useLocale();
  const [show, setShow] = useState(true);
  let t0;
  if ($[0] !== show) {
    t0 = () => {
      setShow(!show);
    };
    $[0] = show;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleClick = t0;
  let t1;
  if ($[2] !== handleClick) {
    t1 = event => {
      if (event.key === "Enter" || event.key === " ") {
        handleClick();
      }
    };
    $[2] = handleClick;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleKeyDown = t1;
  let t2;
  if ($[4] !== handleClick || $[5] !== handleKeyDown || $[6] !== locale || $[7] !== show || $[8] !== t) {
    t2 = show && <nav aria-label={t("account")}><Container><InnerContainer><StyledCreateAccount><InfoIcon /><span><a href={`${process.env.NEXT_PUBLIC_CXP_BASE_PATH}/${locale}/splash`}>{t("createAn")}</a>{t("forEasy")}</span></StyledCreateAccount><StyledCloseIcon tabIndex={0} aria-label={t("close")} onClick={handleClick} onKeyDown={handleKeyDown} role="button" /></InnerContainer></Container></nav>;
    $[4] = handleClick;
    $[5] = handleKeyDown;
    $[6] = locale;
    $[7] = show;
    $[8] = t;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default CreateAccountBanner;